module.exports = __webpack_public_path__ + "static/media/04.f54f943e.jpg";